import {CommonModule} from '@angular/common';
import {NgModule} from '@angular/core';
import {SpecialistRecommendationComponent} from './specialist-recommendation.component';

@NgModule({
  imports: [CommonModule],
  declarations: [SpecialistRecommendationComponent],
  exports: [SpecialistRecommendationComponent]
})
export class SpecialistRecommendationModule {}
